import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import { IconButton } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'PlusMinus' })((theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: 2,
		margin: -9
	},
	button: {
		padding: 9,
		'&:hover': {
			backgroundColor: 'transparent'
		}
	},
	buttonIncrease: {

	},
	buttonDecrease: {

	}
}));

export type IncrementDecrementProps = React.HTMLAttributes<HTMLDivElement> & {
	disableIncrease?: boolean;
	disableDecrease?: boolean;
	onIncrease?: () => void;
	onDecrease?: () => void;
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
};

export const IncrementDecrement: React.FC<IncrementDecrementProps> = (props) => {
	const { classes, className, children, onIncrease, onDecrease, disableDecrease, disableIncrease, ...other } = props;
	const { classes: styles, cx } = useStyles(undefined, { props: { classes } });

	return (
		<div
			data-test='panel-plus-minus'
			className={cx(styles.root, className)}
			{...other}>

			<IconButton
				color='primary'
				data-test='button-decrement'
				disabled={disableDecrease}
				className={cx(styles.button, styles.buttonDecrease)}
				onClick={onDecrease}
				size="large">
				<RemoveCircleOutlineOutlinedIcon fontSize='inherit' />
			</IconButton>

			{children}

			<IconButton
				color='primary'
				data-test='button-increment'
				disabled={disableIncrease}
				className={cx(styles.button, styles.buttonIncrease)}
				onClick={onIncrease}
				size="large">
				<AddCircleOutlineOutlinedIcon fontSize='inherit' />
			</IconButton>

		</div>
	);
};
